import React from "react";
import { AlertCircle, CheckCircle, X } from "lucide-react";

const StatusAlert = ({ emailStatus, onClose, styles, screenSize }) => {
  if (!emailStatus.message) return null;

  return (
    <div style={styles.statusAlert(emailStatus.type)}>
      <div style={styles.alertContent}>
        {emailStatus.type === "error"
          ? <AlertCircle size={screenSize.isMobile ? 14 : 16} />
          : <CheckCircle size={screenSize.isMobile ? 14 : 16} />
        }
        <span>{emailStatus.message}</span>
        <button onClick={onClose} style={styles.alertClose}>
          <X size={screenSize.isMobile ? 12 : 14} />
        </button>
      </div>
    </div>
  );
};

export default StatusAlert;